import { defineMessages } from 'react-intl-next';

export default defineMessages({
    portals: {
        defaultMessage: 'Portals',
        description: 'Text for section resource type in search results',
        id: 'cv.search.portals.portals',
    },
});
